const RESUME_DATE_FIELDS = new Set(["startDate", "endDate"]);

const toDateOrOriginal = (value) => {
  if (value == null || value === "") return value;
  if (value instanceof Date) return value;
  if (typeof value === "number" && Number.isFinite(value)) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
  }
  if (typeof value === "string") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
  }
  return value;
};

const normalizeVideoUrls = (value) => {
  if (!Array.isArray(value)) return value;
  if (!value.some((item) => item && typeof item === "object")) return value;
  return value.map((item) =>
    typeof item === "string" ? item : item?.url || ""
  );
};

export const applyResumeValuesToGenerateCampaign = ({
  resumeValues,
  getValues,
  setValue,
  resumeFieldAliases = null,
}) => {
  const currentValues = getValues() || {};
  const source = resumeValues || {};

  Object.keys(source).forEach((key) => {
    if (!(key in currentValues) || key === "step") return;
    let value = source[key];
    if (value === undefined || typeof value === "function") return;
    if (RESUME_DATE_FIELDS.has(key)) {
      value = toDateOrOriginal(value);
    }
    if (key === "videoUrls") {
      value = normalizeVideoUrls(value);
    }
    setValue(key, value);
  });

  Object.entries(resumeFieldAliases || {}).forEach(([formKey, sourceKey]) => {
    if (source[formKey]) return;
    const aliasValue = source[sourceKey];
    if (aliasValue == null || aliasValue === "") return;
    setValue(formKey, aliasValue);
  });
};
